import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaPhoneAlt,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { Link as RouterLink } from "react-router-dom";
import Logo from "../Imagenes/LOGOTIPO.png";
import "../Css/Footer.css";

const CATEGORIES = [
  { label: "Terreno", cat: "Terreno" },
  { label: "Departamento", cat: "Departamento" },
  { label: "Casa", cat: "Casa" },
  { label: "Oficina", cat: "Oficina" },
  { label: "Edificio comercial", cat: "Edificio Comercial" },
  { label: "PH", cat: "PH" },
  { label: "Lote", cat: "Lote" },
];

export default function Footer({
  phone = "11 3306 1010",
  phoneHref = "1133061010",
  address = "Dr. Enrique Finochieto 484. Barracas, CABA.",
  facebook = "https://www.facebook.com/",
  instagram = "https://www.instagram.com/cancemi.inmobiliaria/",
  matricula = "Matrícula CUCICBA 9212",
}) {
  return (
    <footer className="footer">
      <div className="footer__inner">
        {/* Col 1: Logo + contacto */}
        <div className="footer__col footer__brand">
          <RouterLink to="/">
            <img src={Logo} alt="Cancemi Inmobiliaria" className="footer__logo" />
          </RouterLink>

          <div className="footer__contact">
            <div className="footer__contactItem">
              <FaPhoneAlt aria-hidden="true" />
              <a href={`tel:${phoneHref}`}>{phone}</a>
            </div>
            <div className="footer__contactItem">
              <FaMapMarkerAlt aria-hidden="true" />
              <span>{address}</span>
            </div>
            <div className="footer__matricula">{matricula}</div>
          </div>
        </div>

        {/* Col 2: Redes */}
        <div className="footer__col">
          <h4 className="footer__title">Seguinos en</h4>
          <div className="footer__social">
            <a href={facebook} target="_blank" rel="noreferrer" aria-label="Facebook">
              <FaFacebookF />
            </a>
            <a href={instagram} target="_blank" rel="noreferrer" aria-label="Instagram">
              <FaInstagram />
            </a>
          </div>
        </div>

        {/* Col 3: Filtros por categoría (sin estado) */}
        <nav className="footer__col footer__nav" aria-label="¿Qué estás buscando?">
          <h4 className="footer__title">¿Qué estás buscando?</h4>
          <ul className="footer__links">
            {CATEGORIES.map(({ label, cat }) => (
              <li key={label}>
                <RouterLink to={`/?cat=${encodeURIComponent(cat)}`}>
                  {label}
                </RouterLink>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className="footer__disclaimer">
        Todas las medidas enunciadas son meramente orientativas; las medidas exactas serán
        las que se expresen en el respectivo título de propiedad de cada inmueble. Las fotos,
        imágenes y videos son ilustrativos y no contractuales. Los precios enunciados son
        orientativos y no contractuales.
      </div>
    </footer>
  );
}
